"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { TourKitProvider } from "@repo/onboarding-tour";
import { Provider as JotaiProvider } from "jotai";
import type { ReactNode } from "react";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ClerkProvider>
      <JotaiProvider>
        <TourKitProvider>{children}</TourKitProvider>
      </JotaiProvider>
    </ClerkProvider>
  );
}
